import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Label,
  Form,
  CustomInput,
  FormText,
} from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
} from '../../styled-components';
import { useAlert } from 'react-alert';
import { uploadDocumentForRecurrency } from '../../lib/fetch/contractsAPIs';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';

const INITAL_FILE_FORM_VALUES = {
  file: '',
};

const ModalAddDocument = (props) => {
  const [t] = useTranslation('CONTRACTS');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const { data: contract, className = '', onStatusChanged } = props;

  const [addDocumentModal, setAddDocumentModal] = useState(false);
  const [formValues, setFormValues] = useState(INITAL_FILE_FORM_VALUES);
  const [errors, setErrors] = useState({
    file: false,
  });
  const [firstTry, setFirtsTry] = useState(true);

  const toggleAddDocumentModal = () => {
    setFormValues(INITAL_FILE_FORM_VALUES);
    setAddDocumentModal(!addDocumentModal);
    setFirtsTry(true);
  };

  async function uploadFile(file, toggleAddDocumentModal) {
    showLoading();

    const { error, data } = await uploadDocumentForRecurrency({
      contractId: contract._id,
      data: file,
      newToken,
    });

    if (error) {
      hideLoading();

      toggleAddDocumentModal();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    toggleAddDocumentModal();
    onStatusChanged();
    alert.success(t('COMMON:SUCCESS_UPLOAD'));
  }

  function handleFileChange() {
    const file = formValues.file;

    const fileSize = (file.size / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Max 20Mb');
    } else {
      const data = new FormData();
      data.append('file', file);

      setFirtsTry(false);
      errors.file = false;

      if (file === '') errors.file = true;

      const arrayErrors = Object.values(errors);
      if (!arrayErrors.includes(true)) {
        uploadFile(data, toggleAddDocumentModal);
      }
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ marginLeft: '10px' }}>
          <BtnModalTable
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              toggleAddDocumentModal();
            }}
          >
            {t('ADD_DOCUMENT')}
          </BtnModalTable>
        </div>
      </div>

      <Modal
        isOpen={addDocumentModal}
        toggle={toggleAddDocumentModal}
        className="new-file-modal"
      >
        <ModalHeader toggle={toggleAddDocumentModal}>
          {t('MODAL_ADD_DOCUMENT_TITLE')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleFileChange();
          }}
        >
          <ModalBody>
            <Row>
              <Col sm="12">
                <FormGroup>
                  <Label for="selectFile">
                    {t('FILES:CHOOSE_FILE')}
                    &nbsp;({t('FILES:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                  <CustomInput
                    type="file"
                    id="documentContract"
                    name="documentContract"
                    className="file-dropzone"
                    accept="application/pdf"
                    onChange={(event) =>
                      setFormValues({
                        ...formValues,
                        file: event.target.files[0],
                      })
                    }
                  />
                  {formValues.file === '' && !firstTry && (
                    <FormText className="error-message">
                      {t('FILE_ERROR')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed
              type="button"
              className="uppercase"
              onClick={toggleAddDocumentModal}
            >
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default ModalAddDocument;
